import { FC } from "react"
import { SafetiesAnswerSuccess } from "../../../module/safeties/containers/answerSuccess"

export const SafetiesAnswerSuccessPage: FC = () => <SafetiesAnswerSuccess />
